<template>
  <div class="publication container html-content">
    <!--    <block-breadcrumbs />-->

    <div class="publication-title">
      <h1>{{ PUBLICATION.title }}</h1>

      <vue-client-only>
        <span v-if="adaptive.isDesktop">
          {{ PUBLICATION.publishedOn | fullDate }}
        </span>
      </vue-client-only>
    </div>

    <div
      class="publication-content"
      v-html="PUBLICATION.body"
    />

    <publications-block
      title="Другие новости и акции"
    />
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import VueClientOnly from 'vue-client-only';
import pageMetaMixin from '@/mixins/page-meta-mixin';

import PublicationsBlock from '../components/news/publications-block';

export default {
  name: 'publication',

  components: {
    PublicationsBlock,
    VueClientOnly,
  },

  mixins: [pageMetaMixin],

  inject: ['adaptive'],

  metaInfo() {
    return this.getPageMeta({ pageTitle: this.PUBLICATION.title });
  },

  computed: {
    ...mapGetters({
      PUBLICATION: 'publications/publication',
    }),
  },

  methods: {
    ...mapActions({
      LOAD_PAGE: 'publications/loadPublicationPage',
    }),
  },

  serverPrefetch() {
    return Promise.all([
      this.LOAD_PAGE(),
    ])
  }
};
</script>

<style lang="scss">
.publication {
  h4 {
    font-weight: 600;
  }

  img {
    margin-top: 24px;
  }

  &-title {
    margin-top: 20px;
    padding-bottom: 12px;
    border-bottom: 1px solid $gray_lu;
  }

  &-content {
    margin-top: 24px;
  }

  & > .publications-block {
    margin-top: 56px;
  }
}

@include breakpoint("tablet") {
  //
}

@include breakpoint("desktop") {
  .publication {
    img {
      margin-top: 32px;
    }

    &-title {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin-top: 32px;
      padding-bottom: 16px;

      & > span {
        margin-bottom: 8px;
        color: $gray_l;
      }
    }

    &-content {
      margin-top: 32px;
      max-width: 912px;
    }

    & > .publications-block {
      margin-top: 96px;
    }
  }
}
</style>
